import PageTitleWithTabs from 'common/components/general/PageTitleWithTabs';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import useRouter from 'use-react-router';
import paths from 'routing/routes/_paths';
import list from 'common/assets/svg/common/burger.svg';
import post from 'common/assets/svg/files/bordered/file-empty.svg';

import Menu from './menu';
import Posts from './posts';

const Beacon = () => {
  const { location } = useRouter();
  const showPostsView = useMemo(() => location.pathname.includes('posts'), [location.pathname]);

  return (
    <div>
      <PageTitleWithTabs
        contentWrapperClassName="w-100p"
        titleComponent={
          <div className="ms-3 ps-3 border-start d-flex align-items-center flex-1">
            <span className="pe-3">Beacon.Help Signals</span>
            <strong>/ {showPostsView ? 'Posts' : 'Menu'}</strong>
            {showPostsView && (
              <Link to={`${paths.beacon}/posts/create`} className="btn btn-primary btn-lg ms-auto">
                Add Post
              </Link>
            )}
          </div>
        }
        tabs={[
          { to: paths.beacon, icon: list },
          { to: `${paths.beacon}/posts`, icon: post }
        ]}
      />

      <div className="mt-3">{showPostsView ? <Posts /> : <Menu />}</div>
    </div>
  );
};

export default Beacon;
